import contractor from "./contractor.component";
import contractorUrls from "./contractor.urls";
import ContractorTransforms from "./contractor.transforms";

const contractorModule = angular
  .module("app.components.contractor", [])
  .component("contractorPage", contractor)
  .service("ContractorTransforms", ContractorTransforms)
  .config(contractorUrls);

export default contractorModule;



// WEBPACK FOOTER //
// ./src/pages/contractor/contractor.module.js